/**
 * Decléor — replay the slide text's staggered rise on every slide change.
 *
 * WHY IT IS NEEDED, measured rather than assumed. theme.css lets the first two sections of the page
 * play their hero reveal on load without waiting to be scrolled into view:
 *
 *     .aos-initialized .main-content .shopify-section:nth-child(1) [data-aos=hero],
 *     .aos-initialized .main-content .shopify-section:nth-child(2) [data-aos=hero],
 *     .aos-initialized [data-aos=hero].aos-animate { animation-name: heroFade; … }
 *
 * The slideshow is that first section, so every `[data-aos=hero]` inside it matches. Read on the live
 * page: all three slides carry `aos-init aos-animate` and `animation-name: heroFade` from load, on the
 * two hidden ones as well as on the visible one, and the classes never change when Flickity advances.
 * So the reveal fires ONCE, simultaneously, mostly behind slides nobody is looking at — and the only
 * stagger a visitor ever sees is on whichever slide happened to be showing when the page loaded.
 *
 * (An earlier note in this project claimed the AOS class toggling re-fired the reveal per slide. It does
 * not; the snapshot above is what actually happens.)
 *
 * HOW IT REPLAYS. `animation: none` → read `offsetHeight` to force a reflow → clear the inline value.
 * The stylesheet's animation then starts from the beginning, delay included, so the per-order stagger
 * set in sections/section-slideshow.liquid replays in full. Clearing the property rather than writing a
 * new one keeps every value — duration, easing, the merchant's delays — in CSS where it belongs.
 *
 * The one-frame gap between the two writes shows the element in its base state, which
 * `.aos-initialized [data-aos=hero]` parks at `opacity: 0` — the same state the animation starts from,
 * so there is nothing to see. And it happens under cover of Flickity's own fade between slides.
 *
 * `is-selected` is Flickity's own class on the current cell, watched with a MutationObserver rather
 * than a Flickity event because the instance is not reachable: the bundle is module-scoped and
 * `window.Flickity` is undefined on this store.
 *
 * Runs only on a slideshow whose section marks itself `data-ss-replay` (the "Staggered rise" setting),
 * and stands down entirely under prefers-reduced-motion — the CSS already freezes the reveal there, and
 * replaying nothing on a timer would be pointless work.
 */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var wrappers = document.querySelectorAll('[data-ss-replay]');
  if (!wrappers.length) {
    return;
  }

  function replay(slide) {
    var targets = slide.querySelectorAll('[data-aos="hero"]');
    var i;
    for (i = 0; i < targets.length; i += 1) {
      targets[i].style.animation = 'none';
    }
    /* One reflow for the whole slide, read after every element has been cleared: the browser only has
       to recompute layout once, and each animation then restarts on the same frame so the stagger
       keeps its relative timing. */
    void slide.offsetHeight;
    for (i = 0; i < targets.length; i += 1) {
      targets[i].style.animation = '';
    }
  }

  function watch(wrapper) {
    var slides = wrapper.querySelectorAll('.slideshow__slide');
    if (slides.length < 2) {
      return;
    }

    /* The slide showing at boot is already mid-animation from the page load. Recording it here means
       the first observer callback cannot restart it under the visitor's eyes. */
    var current = wrapper.querySelector('.slideshow__slide.is-selected');

    var observer = new MutationObserver(function () {
      var next = wrapper.querySelector('.slideshow__slide.is-selected');
      if (!next || next === current) {
        return;
      }
      current = next;
      replay(next);
    });

    var i;
    for (i = 0; i < slides.length; i += 1) {
      observer.observe(slides[i], { attributes: true, attributeFilter: ['class'] });
    }
  }

  var j;
  for (j = 0; j < wrappers.length; j += 1) {
    watch(wrappers[j]);
  }
})();
